import React from "react";
import { Box } from "@mantine/core";

interface SegmentedScaleProps {
  value: string;
  onChange: (value: string) => void;
  segments: string[];
  trackBg?: string;
  height?: number;
  className?: string;
}

export const SegmentedScale: React.FC<SegmentedScaleProps> = ({
  value,
  onChange,
  segments,
  trackBg = "#f1f3f5",
  height = 48,
  className,
}) => {
  return (
    <Box
      className={className}
      style={{
        display: "flex",
        border: "1px solid #dee2e6",
        borderRadius: 6,
        padding: 6,
        backgroundColor: trackBg,
        userSelect: "none",
      }}
    >
      {segments.map((segment, index) => {
        const isSelected = value === segment;

        return (
          <Box
            key={segment}
            onClick={() => onChange(segment)}
            style={{
              flex: 1,
              height,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              backgroundColor: isSelected ? "#ffffff" : "transparent",
              boxShadow: isSelected
                ? "0 1px 3px rgba(0,0,0,0.12), 0 1px 1px rgba(0,0,0,0.06)"
                : "none",
              border: isSelected ? "1px solid #dee2e6" : "1px solid transparent",
              borderRadius: 6,
              fontWeight: 600,
              fontSize: 14,
              color: "#212529",
              borderRight:
                index === segments.length - 1
                  ? "none"
                  : isSelected
                  ? "1px solid transparent"
                  : "1px solid #dee2e6",
              userSelect: "none",
            }}
          >
            {index + 1}
          </Box>
        );
      })}
    </Box>
  );
};

export default SegmentedScale;
